module.exports = __webpack_public_path__ + "img/background-document.efcd8af4.svg";